<script setup lang="ts">
import CalendarComponent from '@/components/Calendar/CalendarComponent.vue';

</script>

<template>
  <CalendarComponent />
</template>

<style>
</style>
